import {queryFnFetch} from '@github-ui/react-core/future/query-fn-fetch'
import type {QueryPersister} from '@github-ui/react-query'

/**
 * Shorthand for creating a query config that fetches from a pull request's `page_data` endpoint.
 * Builds the pathname as `/:owner/:repo/pull/:pr_number/page_data/:name`.
 */
export function pageDataQuery<Res, Name extends string>(name: Name, options?: {persister?: QueryPersister}) {
  return {
    queryName: name,
    queryDeps: ({params}: {params: {owner: string; repo: string; pr_number: string}}) => ({
      pathname: `/${params.owner}/${params.repo}/pull/${params.pr_number}/page_data/${name}`,
    }),
    queryFn: async (queryKey: Parameters<typeof queryFnFetch>[0]) => queryFnFetch<Res>(queryKey),
    ...(options?.persister ? {persister: options.persister} : {}),
  }
}
